import type {
  CreateCampaignRequest,
  InviteUserRequest,
  UpdateCampaignRequest,
  UpdateCapabilitiesRequest,
} from '../generated/dtos.gen';

export function createCampaignRequest(
  fields: Pick<CreateCampaignRequest, 'name'> & Partial<CreateCampaignRequest>,
): CreateCampaignRequest {
  return {
    description: null,
    timeZoneId: null,
    candidateName: null,
    campaignTitle: null,
    office: null,
    paidForBy: null,
    electionDate: null,
    campaignEmail: null,
    campaignPhone: null,
    campaignWebsite: null,
    campaignAddress: null,
    facebookUrl: null,
    twitterUrl: null,
    instagramUrl: null,
    campaignCreatorType: null,
    teamSize: null,
    experienceLevel: null,
    existingAssets: null,
    ...fields,
  };
}

export function updateCampaignRequest(fields: Partial<UpdateCampaignRequest>): UpdateCampaignRequest {
  return {
    name: null,
    description: null,
    status: null,
    timeZoneId: null,
    candidateName: null,
    campaignTitle: null,
    office: null,
    paidForBy: null,
    electionDate: null,
    campaignEmail: null,
    campaignPhone: null,
    campaignWebsite: null,
    campaignAddress: null,
    facebookUrl: null,
    twitterUrl: null,
    instagramUrl: null,
    campaignCreatorType: null,
    teamSize: null,
    voiceTranscriptionEnabled: null,
    voiceRetentionDays: null,
    ...fields,
  };
}

export function inviteUserRequest(
  fields: Pick<InviteUserRequest, 'email'> & Partial<InviteUserRequest>,
): InviteUserRequest {
  return {
    presetKey: null,
    capabilities: null,
    canvasserType: null,
    vendorId: null,
    ...fields,
  };
}

export function updateCapabilitiesRequest(fields: Partial<UpdateCapabilitiesRequest>): UpdateCapabilitiesRequest {
  return {
    presetKey: null,
    capabilities: null,
    canvasserType: null,
    vendorId: null,
    clearCanvasserType: false,
    ...fields,
  };
}
